'use client'

// Browser Supabase client (login-system R2, migration-spec/12): cookie-backed session with
// PKCE, publishable key only. Client-hydrated auth islands — no middleware/session work on
// the server, static pages stay static. One instance per tab.
import { createBrowserClient } from '@supabase/ssr'
import type { Database } from './database.types'

let _client: ReturnType<typeof createBrowserClient<Database>> | null = null

export const SUPABASE_CONFIGURED = Boolean(
  process.env.NEXT_PUBLIC_SUPABASE_URL && process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY,
)

export function supabaseBrowser() {
  if (!_client) {
    _client = createBrowserClient<Database>(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY!,
    )
  }
  return _client
}
